import { render } from "./OneDayBooking.vue?vue&type=template&id=21034c63"
import script from "./OneDayBooking.vue?vue&type=script&lang=js"
export * from "./OneDayBooking.vue?vue&type=script&lang=js"

import "./OneDayBooking.vue?vue&type=style&index=0&id=21034c63&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__